export default function Title ({text}) {
    return (
        <p style={{fontWeight:600, fontSize:20, marginBottom:25, marginTop:0, paddingTop:15, fontFamily:'m_semi_bold'}}>{text}</p>
    );
};